module.exports = __webpack_public_path__ + "static/media/received.d24f7fb9.svg";